// Librerias
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Components
import Screen from "@Components/Screen";
import IkTable from "@Components/IkTable";

// Redux
import genericAction from "@Actions/generic";
import { connect } from "react-redux";

//	Utils
import dataHandler from "@Utils/dataHandler";

// Modals
import ConfirmModal from "@Modals/ConfirmModal";
import GroupCrud from "./Modals/GroupCrud";

// Styles
import styles from "./styles.module.css";

const Group = ({ dispatch, companyName, userName }) => {
	const [tableValue, setTableValue] = useState([]);
	const [openConfirmModal, setOpenConfirmModal] = useState(false);
	const [openGroupCrud, setOpenGroupCrud] = useState(false);
	const [modalOption, setModalOption] = useState("");
	const [presetMessages, setPresetMessages] = useState("");
	const [types, setTypes] = useState("");
	// Bots
	const [bots, setBots] = useState([]);
	// Table hooks
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState(null);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const defaultParams = { page: 1, orderKey: "id", orderDir: "desc", rows: 15 };

	useEffect(() => {
		(async () => {
			const groupsPromise = dataHandler({ dispatch, url: "groups", params: defaultParams });
			const typesPromise = dispatch(genericAction({ method: "get", route: "types/groups" }));
			const presetMessagesPromise = dispatch(genericAction({ method: "get", route: "presetMessages/all" }));
			const botsPromise = dataHandler({
				dispatch,
				url: "bots/all",
			});
			const [groupsResponse, typesResponse, presetMessagesResponse, botsResponse] = await Promise.all([
				groupsPromise,
				typesPromise,
				presetMessagesPromise,
				botsPromise,
			]);
			setBots(botsResponse);
			setTypes(typesResponse);
			setPresetMessages(presetMessagesResponse);
			setFilteredItems(groupsResponse.items);
			setFilteredCount(groupsResponse.count);
		})();
	}, []);

	// Modal handler
	const modalData = (name, item) => {
		setTableValue(item);
		setModalOption(name);
		setOpenGroupCrud(true);
	};

	// Table Handler
	const handlerData = async (params, printable) => {
		const data = await dataHandler({ dispatch, url: "groups", params });
		if (printable) {
			setFilteredPrintData(data.items);
		} else {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
		}
	};

	const handleButtom = (name, item) => {
		switch (name) {
			case "Watch":
				modalData(name, item);
				break;
			case "Edit":
				modalData(name, item);
				break;
			case "Eraser":
				setOpenConfirmModal(true);
				setTableValue(item);
				break;
			case "Add":
				modalData(name, []);
				break;
			default:
				break;
		}
	};
	const apiData = async (name) => {
		switch (name) {
			case "Edit":
				setOpenGroupCrud(false);
				break;
			case "Eraser":
				setOpenConfirmModal(false);
				await dispatch(genericAction({ method: "delete", route: `groups/${tableValue.id}` }));
				break;
			default:
				break;
		}

		const profilesResponse = await dataHandler({ dispatch, url: "groups", params: defaultParams });
		setFilteredCount(profilesResponse.count);
		setFilteredItems(profilesResponse.items);
	};
	return (
		<Screen hasSidebar hasHeader headerTitle="Grupos">
			<div className={styles.container}>
				<div className={styles.containerTableGroup}>
					<div className={styles.tableGroupList}>
						<IkTable
							data={filteredItems}
							columns={[
								{
									label: "Acciones",

									action: [
										{ content: "trash", color: "#b43333", onClick: "Eraser", type: "icon" },
										{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" },
									],

									dataPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{
									label: "ID",
									key: "id",
									format: "string",
									dataPosition: "center",

									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
								},

								{
									label: "Nombre",
									key: "name",
									format: "string",
									width: 3,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
									headerPosition: "left",
								},
								{
									label: "Tipo",
									key: "type.name",
									format: "string",
									width: 2,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
									dataPosition: "left",
									headerPosition: "left",
								},
								{
									label: "Entrada de Chat",
									key: "settings.chatEnter",
									format: "boolean",
									width: 1,
									canFilter: false,
									canSort: false,
									dataPosition: "left",
									headerPosition: "left",
								},
								{
									label: "Utiliza Horario",
									key: "settings.useSchedule",
									format: "boolean",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{
									label: "Bot",
									key: "bot.name",
									format: "string",
									width: 15,
									canFilter: false,
									canSort: false,
									dataPosition: "left",
									headerPosition: "left",
								},
							]}
							totalRows={filteredCount}
							filteredPrintData={filteredPrintData}
							defaultParams={defaultParams}
							dataHandler={handlerData}
							handlerTable={handleButtom}
							addButton={{ label: "Agregar" }}
							mobileCardView
							cardLine1={[
								{ key: "id", label: "ID" },
								{ key: "name", label: "Nombre" },
								{ key: "type.name", label: "Tipo" },
							]}
							cardLine2={[
								{ key: "type.name", label: "Tipo" },
								{ key: "settings.chatEnter", label: "Entrada de Chat" },
								{ key: "settings.useSchedule", label: "Utiliza Horario" },
							]}
							searcher={{ width: "40rem", hideOnMobile: true }}
							hidePrintButtons
							print={{ printHeader: { company: companyName, title: "Grupos", user: userName } }}
						/>
					</div>
				</div>
			</div>
			{openGroupCrud && (
				<GroupCrud
					apiData={apiData}
					tableValue={tableValue}
					onClose={() => {
						setOpenGroupCrud(false);
					}}
					modalCrud={modalOption}
					types={types}
					presetMessages={presetMessages}
					bots={bots}
				/>
			)}
			{openConfirmModal && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar"
					buttonLabel="Eliminar"
					content="Está seguro que desea eliminar el grupo"
					focus={tableValue.name}
					onConfirm={() => {
						apiData("Eraser");
					}}
					onDismiss={() => {
						setOpenConfirmModal(false);
					}}
				/>
			)}
		</Screen>
	);
};

function mapStateToProps({ user, company }) {
	return {
		companyName: company.name,
		userName: user.name,
	};
}

Group.propTypes = {
	dispatch: PropTypes.func,
	companyName: PropTypes.string,
	userName: PropTypes.string,
};
export default connect(mapStateToProps)(Group);
